import env from '../utils/env'
const jsonLink = env.REACT_APP_DATA_RELEASES_URL;

export default jsonLink;